import { RefObject, useEffect, useRef } from 'react';

// Markdown, code blocks, and images keep growing the list after the first paint.
const KEEP_AT_BOTTOM_MS = 1500;

export function useScrollToLatestOnOpen(
  scrollContainerRef: RefObject<HTMLElement | null> | undefined,
  conversationId: string | null,
  hasMessages: boolean
) {
  const openedConversationIdRef = useRef<string | null>(null);

  useEffect(() => {
    const container = scrollContainerRef?.current;
    if (!conversationId || !hasMessages) {
      openedConversationIdRef.current = null;
      return undefined;
    }
    if (!container || openedConversationIdRef.current === conversationId) return undefined;
    openedConversationIdRef.current = conversationId;

    const scrollToEnd = () => {
      container.scrollTop = container.scrollHeight;
    };
    scrollToEnd();

    const observer = new ResizeObserver(scrollToEnd);
    if (container.firstElementChild) observer.observe(container.firstElementChild);

    const stop = () => {
      observer.disconnect();
      window.clearTimeout(timer);
      container.removeEventListener('wheel', stop);
      container.removeEventListener('touchstart', stop);
    };
    const timer = window.setTimeout(stop, KEEP_AT_BOTTOM_MS);
    container.addEventListener('wheel', stop, { passive: true });
    container.addEventListener('touchstart', stop, { passive: true });

    return stop;
  }, [scrollContainerRef, conversationId, hasMessages]);
}
